import script from "./TemplateCheck.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateCheck.vue?vue&type=script&setup=true&lang=js"

import "./TemplateCheck.vue?vue&type=style&index=0&id=31badb8a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31badb8a"]])

export default __exports__